import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useMessageStore } from '../stores/messageStore';
import { useLeaseStore } from '../stores/leaseStore';
import { notificationTriggers } from '../services/notificationTriggers';

export const useNotifications = () => {
  const { user } = useAuth();
  const { conversations } = useMessageStore();
  const { requests } = useLeaseStore();

  useEffect(() => {
    if (!user) return;

    // Set up message listeners
    const unsubscribeMessages = useMessageStore.subscribe(
      (state, prevState) => {
        const newMessages = state.conversations.flatMap(conv => 
          conv.messages.filter(msg => 
            !prevState.conversations
              .find(c => c.id === conv.id)?.messages
              .find(m => m.id === msg.id) &&
            msg.senderId !== user.id
          )
        );

        newMessages.forEach(msg => {
          const conversation = state.conversations.find(c => 
            c.messages.some(m => m.id === msg.id)
          );
          if (conversation) {
            notificationTriggers.onNewMessage(
              conversation.id,
              msg.senderId,
              user.id
            );
          }
        });
      }
    );

    // Set up lease request listeners
    const unsubscribeLeases = useLeaseStore.subscribe(
      (state, prevState) => {
        // New applications
        const newRequests = state.requests.filter(
          req => !prevState.requests.find(r => r.id === req.id)
        );
        newRequests.forEach(req => {
          notificationTriggers.onApplicationSubmitted(req.id);
        });

        // Status changes
        state.requests.forEach(req => {
          const prevReq = prevState.requests.find(r => r.id === req.id);
          if (prevReq && prevReq.status !== req.status) {
            if (req.status === 'approved') {
              notificationTriggers.onApplicationApproved(req.id);
            } else if (req.status === 'rejected') {
              notificationTriggers.onApplicationRejected(req.id);
            }
          }

          // Deposit payments
          if (prevReq && !prevReq.depositPaid && req.depositPaid) {
            notificationTriggers.onDepositReceived(req.id, req.listing.price * 0.05);
          }
        });
      }
    );

    return () => {
      unsubscribeMessages();
      unsubscribeLeases();
    };
  }, [user]);
};